import { getCoachBots } from "../apis/callLogs";
import { useStoreCoachBotsGet } from "../stores/useStoreCoachBotsGet";
import { useSmartQuery } from "./useSmartQuery";

export const useCoachBotsGet = (workspaceId) => {
  const { coachBots, setCoachBots } = useStoreCoachBotsGet();

  const shouldFetch = !!workspaceId;

  const query = useSmartQuery(
    ["get_coachbots", workspaceId],
    () =>
      getCoachBots({
        options: { headers: { "X-Workspace-Id": workspaceId } },
      }),
    {
      condition: shouldFetch, // ✅ No need to return early
      zustandSetter: setCoachBots,
    }
  );

  return {
    coachBots,
    ...query,
  };
};
